module.exports = __webpack_public_path__ + "static/img/netlify-cms-logo.5cf356c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/netlify-cms-logo.svg
// module id = h6sr
// module chunks = 1